module.exports = __webpack_public_path__ + "img/title2.d30c3a92.png";